import { IdTopShell } from './shells/IdTopShell'
import { IdBottomShell } from './shells/IdBottomShell'

export function HeaderShell() {
  return (
    <>
      {/* Desktop/tablet: top header */}
      <div className="hidden md:block">
        <IdTopShell />
      </div>

      {/* Mobile: top header (simplified) + bottom bar */}
      <div className="md:hidden">
        <IdTopShell />
        <IdBottomShell />
      </div>
    </>
  )
}
